import Analytics from 'analytics'
import segmentPlugin from '@analytics/segment'
import { getLiveConfigurationCache } from './configuration/configurationCache'
import cdpDumpPlugin from './cdpDumpPlugin'
import { shouldPresentBFeature } from './featureCohortTesting'

let segmentAnalytics = null
let plickersAnalytics = null

function initAnalytics() {
  segmentAnalytics = Analytics({
    app: 'plickers-web-students',
    plugins: [
      segmentPlugin({
        writeKey: process.env.REACT_APP_SEGMENT_KEY,
      }),
    ],
  })
  plickersAnalytics = Analytics({
    app: 'plickers-web-students',
    plugins: [
      cdpDumpPlugin({
        appName: 'plickers-web-students',
        writeKey: process.env.REACT_APP_CDPDUMP_WRITE_KEY,
        host: process.env.REACT_APP_CDPDUMP_HOST,
        endpointPrefix: '/cdp/v1',
        // enableDebugLogging: true, // enable this to get more logs into browser console
      }),
    ],
  })
}

export function getAnalyticsProvider() {
  const liveConfig = getLiveConfigurationCache() || {}
  const {
    analyticsProviderProbabilityAnonymous,
  } = liveConfig

  const segmentAnonymousId = window.analytics?.user?.().anonymousId()
  const defaultProbabilityAnonymous = process.env.REACT_APP_ANALYTICS_PROVIDER_DEFAULT_PROBABILITY_ANONYMOUS || '0'
  const anonymousProbability = analyticsProviderProbabilityAnonymous ?? defaultProbabilityAnonymous
  console.log(
    '[ANALYTICS] ANONYMOUS PROBABILITY', anonymousProbability,
    'default:', defaultProbabilityAnonymous,
    'analyticsProviderProbabilityAnonymous:', analyticsProviderProbabilityAnonymous,
    'segmentAnonymousId:', segmentAnonymousId,
  )
  if (segmentAnonymousId) {
    return shouldPresentBFeature('analyticsProviderAnonymous', segmentAnonymousId, anonymousProbability) ?
      'plickers' : 'segment'
  // } if (parseInt(anonymousProbability, 10) === 100) {
  //   // if no userId or segment anonymousId is available and
  //   // anonymousProbability is 100, choose plickers
  //   return 'plickers'
  }
  // if no segment anonymous id, default to segment
  return 'segment'
}

function getAnalyticsInstance() {
  const analyticsProvider = getAnalyticsProvider()
  console.log('[ANALYTICS] Selected provider:', analyticsProvider)
  if (analyticsProvider === 'segment' && isSegmentInitialized()) {
    return segmentAnalytics
  }
  if (analyticsProvider === 'plickers') {
    return plickersAnalytics
  }
}

function isSegmentInitialized() {
  return !!window.analytics
}

function track(eventName, properties = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.track(eventName, properties)
  }
}

function page(pageName, properties = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.page({
      name: pageName,
      ...properties,
    })
  }
}

export default {
  initAnalytics,
  track,
  page,
}
